import { isMain } from '@/utils/tools'
// 新测评系统
// 我的
let MsMY = () => import( /* webpackChunkName: "group-ms_my" */ '@/views/measurement_system/ms_my/index')
// 个人设置
let msPersonalSettings = () => import( /* webpackChunkName: "group-personal_settings" */ '@/views/measurement_system/personal_settings/index')
// 个人信息
let msInformation = () => import( /* webpackChunkName: "group-ms_information" */ '@/views/measurement_system/ms_information/index')
// 报告列表
let msReportList = () => import( /* webpackChunkName: "group-ms_report_list" */ '@/views/measurement_system/ms_report_list/index')
// 套餐详情
let msPackageGoods = () => import( /* webpackChunkName: "group-ms_package_goods" */ '@/views/measurement_system/ms_package_goods/index')
// 套餐详情 职业发展突破营测评详情
let msBtc = () => import( /* webpackChunkName: "group-ms_package_goods" */ '@/views/measurement_system/ms_btc/index')
// 领取测评
let receiveCeping = () => import( /* webpackChunkName: "group-receive_ceping" */ '@/views/measurement_system/receive_ceping/index')
// 获取测评码
let receiveSuccess = () => import( /* webpackChunkName: "group-receive_success" */ '@/views/measurement_system/receive_success/index')
// 白名单
let msRoster = () => import( /* webpackChunkName: "group-ms_roster" */ '@/views/measurement_system/ms_roster/index')

// 报告列表
let extReportList = () => import( /* webpackChunkName: "group-ext_report_list" */ '@/views/ext/ms_report_list/index')
// 套餐详情
let extPackageGoods = () => import( /* webpackChunkName: "group-ext_package_goods" */ '@/views/ext/ms_package_goods/index')

// ------------------------------------------------------------
// 上线判断

if (!isMain()) {

}


export default [
  {
    path: '/ms_my', //
    name: '我的',
    component: MsMY
  },
  {
    path: '/my_personal_settings', //
    name: '个人设置',
    component: msPersonalSettings
  },
  {
    path: '/ms_information', //
    name: '个人信息',
    component: msInformation
  },
  {
    path: '/ms_report_list', //
    name: '报告列表',
    component: msReportList
  },
  {
    path: '/ms_package_goods', //
    name: '测评详情',
    component: msPackageGoods
  },
  {
    path: '/ms_btc', //
    name: '职业发展突破营测评详情',
    component: msBtc
  },
  {
    path: '/receive_ceping', //
    name: '加载中',
    component: receiveCeping
  },
  {
    path: '/receive_success', //
    name: '加载中',
    component: receiveSuccess
  },
  {
    path: '/ms_roster', //
    name: '加载中',
    component: msRoster
  },
  {
    path: '/ext_report_list', //
    name: '订单列表',
    component: extReportList
  },
  {
    path: '/ext_package_goods', //
    name: '测评详情',
    component: extPackageGoods
  },
]


